import { wait } from '../common'
const ajaxWait = 0

const block = document.querySelector('.vp-block-form-subscriptions')
const dom = {
  serverMessage: '.server-message',
  id_contact: '.id_contact',
  preferences: '.preferences',
  processPreferences: '.preferences .process',
  abonom: '#subscriptions-abonom',
  types: '.types-om',
  typesList: '.select-types-om',
  regions: '.regions-om',
  regionsList: '.select-regions-om',
  abonnews: '#subscriptions-abonnews',
  nonact: '#subscriptions-nonact',
}

if (block) {
  // populate dom references
  for (const [k, v] of Object.entries(dom)) {
    if (typeof v === 'string') dom[k] = block.querySelector(v)
    if (Array.isArray(v)) dom[k] = block.querySelectorAll(v[0])
  }

  // events
  dom.processPreferences.addEventListener('click', save)
  dom.typesList.addEventListener('input', (e) => {
    dom.types.value = [...dom.typesList.querySelectorAll('input:checked')]
      .map((e) => e.value)
      .join(',')
  })
  dom.regionsList.addEventListener('input', (e) => {
    dom.regions.value = [...dom.regionsList.querySelectorAll('input:checked')]
      .map((e) => e.value)
      .join(',')
  })
}

async function save() {
  dom.serverMessage.innerHTML = ''
  dom.preferences.classList.add('disabled')

  const url = new URL(block.dataset.url)
  url.searchParams.set('action', block.dataset.action)
  url.searchParams.set('nonce', block.dataset.nonce)
  url.searchParams.set('step', 'save')
  url.searchParams.set('id_contact', dom.id_contact.value)
  url.searchParams.set('abonom', dom.abonom.checked ? '1' : '0')
  url.searchParams.set('abonnews', dom.abonnews.checked ? '1' : '0')
  url.searchParams.set('nonact', dom.nonact.checked ? '1' : '0')
  url.searchParams.set('region_om', dom.regions.value)
  url.searchParams.set('type_mission', dom.types.value)

  try {
    response = await fetch(url)
  } catch (error) {
    dom.serverMessage.innerHTML = 'Pas de réseau disponible'
    return
  }

  dom.preferences.classList.remove('disabled')

  // http error
  if (!response.ok) {
    dom.serverMessage.innerHTML = `Une erreur est survenue (${response.status} ${response.statusText})`
    return
  }

  const json = await response.json()
  // console.log(json)

  // api error
  if (json.data.kookline_error) {
    dom.serverMessage.innerHTML =
      "Une erreur est survenue lors de l'appel à l'api de données."
    return
  }

  if (!json.data.response.success) {
    dom.serverMessage.innerHTML = block.dataset.messageSaveError
  } else {
    dom.serverMessage.innerHTML = block.dataset.messageSaveOk
  }
}
